export default {
  results: {
    detailOffers: null,
    supposedDetails: null
  }

};



/** WEBPACK FOOTER **
 ** ./src/components/Search/redux/searchState.js
 **/